export const TIPO_CONCILIACION = {
  MANUAL: 1,
  FORZADA: 2,
} as const

export type TipoConciliacionType =
  (typeof TIPO_CONCILIACION)[keyof typeof TIPO_CONCILIACION]
